import React from 'react'
import createReactClass from 'create-react-class'
import StarRating from 'components/shared/StarRating'

var RatingsForm = createReactClass({
  getInitialState: function () {
    return {
      note: this.props.note
    }
  },
  handleChangedRating: function (note) {
    this.setState({ note: note })
  },
  submitRating: function () {
    var req = {
      rating: {
        toto: 'tata',
        note: this.state.note
        // comment: this.refs.ratingComment.value
      }
    }
    $.ajax({
      url: '/ratings/',
      data: req,
      method: 'POST',
      dataType: 'json',
      cache: false,
      success: function (data) {}
    })
  },
  render: function () {
    return (
      <div>
        <StarRating
          note={this.state.note}
          editable={true}
          handleChangedRating={this.handleChangedRating}
        />
        <button onClick={this.submitRating}>SUBMIT</button>
      </div>
    )
  }
})

export default RatingsForm
